// src/PaymentProcess.jsx
import { useParams } from "react-router-dom";
import React from "react";

const PaymentProcess = () => {
  const { paymentId } = useParams();

  return (
    <div className="p-6 max-w-xl mx-auto mt-10 bg-white shadow rounded">
      <h2 className="text-xl font-semibold mb-4">Processing Payment</h2>
      <p>You selected payment method ID: <strong>{paymentId}</strong></p>
      <p>(Simulate order placement here...)</p>
    </div>
  );
};

export default PaymentProcess;
